import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';

@Component({
  name: 'ed-class-schedule-header',
})
export default class EdClassScheduleHeaderComponent extends Vue {
  @Emit('onBack')
  emitOnBack() {
    return;
  }
}